const isValidHeight = (height) => {
    if (height) {
        const feet = height.split('ft')[0].trim();
        const inches = height.split('ft')[1].split('in')[0].trim();
        if (feet > 0 && inches >= 0 && inches !== "") {
            return true;
        } 
            return false;
        
    }
    return false;
};

const isValidWeight = (weight) => {
    const wts = parseInt(weight);
    if (weight && wts >= 78 && wts <= 395) {
        const wt = weight.split(' ')[0].trim();
        if (wt) {
            return true;
        } 
            return false;
        
    }
    return false;
};
export { isValidHeight, isValidWeight };



// WEBPACK FOOTER //
// ./src/components/Common/CheckValidHeightOrWeight.js